/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { UserScreeningStatuses } from './'

/**
 *
 * @export
 * @interface UserScreeningRecord
 */
export interface UserScreeningRecord {
  /**
   * The user ID assigned by the system when the userScreeningUsers was first created.
   * @type number
   * @memberof UserScreeningRecord
   */
  userScreeningUserKey: number
  /**
   * The same email address used to send the invitation.
   * @type string
   * @memberof UserScreeningRecord
   */
  userEmail: string
  /**
   * The userKey belongs the userEmail.
   * @type number
   * @memberof UserScreeningRecord
   */
  userKey?: number
  /**
   * An external identifier that links this user to their corresponding record in the external screening system (Ministry Safe).
   * @type number
   * @memberof UserScreeningRecord
   */
  providerUserId?: number
  /**
   * The unique identifier for the userScreening.
   * @type number
   * @memberof UserScreeningRecord
   */
  userScreeningKey: number
  /**
   * Represents the name of the screening service provider: Currently only MinistrySafe.
   * @type string
   * @memberof UserScreeningRecord
   */
  provider: string
  /**
   * Stores screening type: Background check or SafetyTraining.
   * @type string
   * @memberof UserScreeningRecord
   */
  screeningType: UserScreeningRecordScreeningTypeEnum
  /**
   * The date the record was requested, formatted as yyyy-MM-dd.
   * @type Date
   * @memberof UserScreeningRecord
   */
  dateRequested: Date
  /**
   *
   * @type UserScreeningStatuses
   * @memberof UserScreeningRecord
   */
  status?: UserScreeningStatuses
  /**
   * The most recent date when the status was updated, formatted as yyyy-MM-dd.
   * @type Date
   * @memberof UserScreeningRecord
   */
  statusDate: Date
  /**
   * The date until which the status remains valid, formatted as yyyy-MM-dd.
   * @type Date
   * @memberof UserScreeningRecord
   */
  validTo: Date
}

/**
 * @export
 * @enum {string}
 */
export enum UserScreeningRecordScreeningTypeEnum {
  BackgroundCheck = 'Background Check',
  SafetyTraining = 'Safety Training',
}

export function UserScreeningRecordFromJSON(json: any): UserScreeningRecord {
  return UserScreeningRecordFromJSONTyped(json, false)
}

export function UserScreeningRecordFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserScreeningRecord {
  if (json === undefined || json === null) {
    return json
  }
  return {
    userScreeningUserKey: json['userScreeningUserKey'],
    userEmail: json['userEmail'],
    userKey: !exists(json, 'userKey') ? undefined : json['userKey'],
    providerUserId: !exists(json, 'providerUserId')
      ? undefined
      : json['providerUserId'],
    userScreeningKey: json['userScreeningKey'],
    provider: json['provider'],
    screeningType: json['screeningType'],
    dateRequested: new Date(json['dateRequested']),
    status: !exists(json, 'status') ? undefined : json['status'],
    statusDate: new Date(json['statusDate']),
    validTo: new Date(json['validTo']),
  }
}

export function UserScreeningRecordToJSON(
  value?: UserScreeningRecord | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    userScreeningUserKey: value.userScreeningUserKey,
    userEmail: value.userEmail,
    userKey: value.userKey,
    providerUserId: value.providerUserId,
    userScreeningKey: value.userScreeningKey,
    provider: value.provider,
    screeningType: value.screeningType,
    dateRequested: value.dateRequested.toISOString().substr(0, 10),
    status: value.status,
    statusDate: value.statusDate.toISOString().substr(0, 10),
    validTo: value.validTo.toISOString().substr(0, 10),
  }
}
